import { render, staticRenderFns } from "./syncTime.vue?vue&type=template&id=1fe217ba&"
import script from "./syncTime.vue?vue&type=script&lang=ts&"
export * from "./syncTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports